import { MemberContent } from "../../components/kaya"

export default function Member () {

  return (

    <>
        <MemberContent/>
    </>

  )

}